<template>
  <main>
    <div class="container">
      <div class="row">
        <div class="col_xl_12 col_l_12 col_m_12 col_s_12">
          <img
            src="@/assets/img/error_page_icon.svg"
            alt=""
            class="error_icon"
          />

          <p class="tac terms_title">
            Oops! Something went <br />
            wrong.
          </p>

          <router-link to="/" class="color_btn hover_op return_home"
            >Return home</router-link
          >
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: "404",
};
</script>

<style></style>
